import React, { useContext, useState,useEffect } from "react";
// import Spinner from "../pages/sample/spinner";
import Spinner from "../pages/sample/spinner";
import { UserContext } from "../context/UserContext";
const Signin = () => {
    const context = useContext(UserContext);
	useEffect(() => {
        console.log(process.env.NODE_ENV)
        context.setUser(null);
        localStorage.clear();
        if (process.env.NODE_ENV === "development") {
          window.location.assign(process.env.REACT_APP_EDUPLUSNOW_REDIRECTION_URL)
          } else if (process.env.NODE_ENV === "test") {
            window.location.assign(process.env.REACT_APP_EDUPLUSNOW_REDIRECTION_URL)
          } else {
            window.location.assign(process.env.REACT_APP_EDUPLUSNOW_REDIRECTION_URL)
          }
	
	}, []);// eslint-disable-line react-hooks/exhaustive-deps
    return (
        <div>
      <br />
      <br />
      <br />
    
      <br />
      <br />
      <br />
      <Spinner/>
      <center>Please Wait while Redirecting..</center>
      <br /><br />
      <br />
      <br />
      <br />
      <br /><br />
      <br />
      <br />
      <br />
      <br />
    </div>
    );
};

export default Signin;